/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, TextField, Typography } from "@mui/material"
import { DocumentSnapshot, collection, doc, getDoc } from "firebase/firestore"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { db } from "../firebase"
import dayjs from "dayjs"

export const IndividualReceipt = () => {
  const urlParams = useParams<{ individualId: string }>()
  const [individualInfo, setIndividualInfo] = useState<Record<string, string|number>>()
  const [errorMessage, setErrorMessage] = useState<string>('')

  useEffect(() => {
    getDoc(doc(collection(db, 'individuals'), urlParams.individualId)).then((_: DocumentSnapshot) => {
      _.exists() ? setIndividualInfo(_.data()) : setErrorMessage("該当のデータは存在しません")
      if(!_.data()?.individualNo) setErrorMessage("該当のデータは存在しません")
    })
  }, [urlParams])

  return (
    <Box display="contents" justifyItems="center">
      <Box display="flex" justifyContent="center" mt={2}>
        <Typography variant="h4">個体預かり証</Typography>
      </Box>
      <Box display="flex-col" m={1} justifyItems="center">
        <Box display="flex" justifyContent="center">
          <Typography variant="subtitle2" color="red">{errorMessage}</Typography>
        </Box>
      </Box>
      {
        individualInfo &&
        <Box display="flex-col" justifyContent="center">
          <Box component="form" sx={{ '& .MuiTextField-root': { m:1}}}>
            <Box display="flex" justifyContent="center" >
              <TextField label="捕獲年月日" value={dayjs(individualInfo.captureDatetime).format('YYYY/MM/DD')} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
              <TextField label="個体識別番号" value={individualInfo.individualNo} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
            </Box>
            <Box display="flex" justifyContent="center" >
              <TextField label="捕獲者氏名" value={individualInfo.name} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
              <TextField label="捕獲地" value={individualInfo.captureLocation} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
            </Box>
            <Box display="flex" justifyContent="center" >
              <TextField label="捕獲方法" value={individualInfo.captureMethod} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
              <TextField label="月齢 (推定)" value={individualInfo.age} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
            </Box>
            <Box display="flex" justifyContent="center" >
              <TextField label="性別" value={individualInfo.sex} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
              <TextField label="体重" value={`${individualInfo.weight}kg`} sx={{ m: 1, width: '25ch' }} inputProps={{ readOnly: true }}/>
            </Box>
          </Box>
          <Box display="flex" justifyContent="center" mt={2}>
            <Typography variant="h5">上記の個体をお預かりいたしました。</Typography>
          </Box>
          <Box display="flex-col" justifyContent="center" mt={2}>
            <Typography className="text-center">りんどう</Typography>
            <Typography className="text-center">歌志内市字歌神３６</Typography>
            <Typography className="text-center">0125−35−9107</Typography>
          </Box>
          <Box display="flex" justifyContent="center" mt={2} className="no-print">
            <Button className="print:hidden" variant="contained" onClick={() => window.print()}>印刷</Button>
          </Box>
        </Box>
      }
    </Box>
  )
}
